// extracted by mini-css-extract-plugin
export default {"limits-hint-wrapper":"HqbGviZnaNWz6PJ"};